module.exports = __webpack_public_path__ + "img/tariffs_icon-sidebar.b2bde322.svg";